import axios from 'axios';

const editFarmerDetails = (values) => {
    const loggedInUser = JSON.parse(localStorage.getItem("user") || "{}");

    delete values.issues;
    delete values._id;
    delete values.__v;

    values.updatedAt = new Date().toISOString();
    values.updatedBy = loggedInUser.fullName || "";

    return axios
        .post(`${process.env.REACT_APP_API_URL}/api/farmer/editFarmer`, values)
        .then((res) => {
            return res;
        })
        .catch((err) => {
            //console.log("C-ERRCODE: " + JSON.stringify(code));
            return err;
        });
}
export default editFarmerDetails;